// Utility to reset all localStorage data for development
export const resetAllData = () => {
  // Clear all localStorage items related to the app
  const keysToRemove = [
    'auth-storage',
    'workout-storage', 
    'nutrition-storage'
  ]
  
  keysToRemove.forEach(key => {
    localStorage.removeItem(key)
  })
  
  console.log('All app data cleared from localStorage')
  
  // Reload the page to reinitialize stores
  window.location.reload()
}

// Add to window for easy access in dev tools
if (typeof window !== 'undefined') {
  window.resetNeatFitData = resetAllData
}